import { useQuery } from "@tanstack/react-query"

import type { GID } from "@unlikelystudio/commerce-connector"

import type { Nullish } from "~/@types/generics"
import { LOCATIONS_COUNT } from "~/lib/shopify/constants/locations"
import { getSfVariantById } from "~/lib/shopify/queries/get-sf-variant-by-id"
import useLocale from "~/hooks/useLocale"

export function useVariantsQuantity(ids: Nullish<GID[]>) {
  const locale = useLocale()

  return useQuery({
    queryKey: ["ClientVariantQuantity", ids, locale],
    cacheTime: 0,
    queryFn: async () => {
      if (!ids) return null

      const variants = await Promise.all(
        ids.map(
          async (id) =>
            await getSfVariantById({
              id,
              locale: locale,
              includeQuantityAvailable: true,
              storeAvailabilityFirst: LOCATIONS_COUNT,
              nextTags: [],
            })
        )
      )

      return variants.map(({ variant }) => variant?.quantityAvailable ?? 0)
    },
    keepPreviousData: true,
  })
}
